import {
  API_STATES
} from '@/helpers'

const state = {
  budgetsGetState        : API_STATES.NOT_REQUESTED,
  budgetsGetError        : null,
  budgetDeleteState      : API_STATES.NOT_REQUESTED,
  budgetDeleteError      : null,
  budgetCreateState      : API_STATES.NOT_REQUESTED,
  budgetCreateError      : null,
  budgets                : [],
  budgetUpdateState      : API_STATES.NOT_REQUESTED,
  budgetUpdateError      : null,
  storeBudgetCreateState : API_STATES.NOT_REQUESTED,
  storeBudgetUpdating    : [],
  storeBudgetCreateError : null,
  storeBudgetDeleting    : [],
  storeBudgetDeleteError : null,
  storeBudgets           : [],
  budget                 : {}
}

export default state